import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section id="como-funciona" className="w-full bg-ink py-20 lg:py-28" data-id="element-209" data-mp="7ugc4glpdzx9">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-210" data-mp="3pz9po9az7wpv">
        <div className="max-w-2xl" data-id="element-211" data-mp="3q0uk7yxajfnq">
          <p className="mb-4 text-xs uppercase tracking-[0.28em] text-gold" data-id="element-212" data-mp="3tzbmo55ro1yt">{t.steps.eyebrow}</p>
          <h2 className="font-display text-3xl font-bold uppercase leading-tight text-cream sm:text-4xl lg:text-[2.9rem]" data-id="element-213" data-mp="lk09f6wim4z6">
            {t.steps.title}
          </h2>
        </div>

        <ol className="mt-12 border-l border-gold/25" data-id="element-214" data-mp="cs7zqyfbezvn">
          {t.steps.items.map((step, index) => <li key={step.title} className="relative pb-10 pl-8 last:pb-0 sm:pl-12" data-id="element-215" data-mp="gt1otv4hukq4" data-mpi={index}>
              <span className="absolute -left-[9px] top-1 h-[18px] w-[18px] rounded-full bg-gold" aria-hidden="true" data-id="element-216" data-mp="14je6vytgdxuf" />
              <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-5" data-id="element-217" data-mp="19b5o3iqpyr7w">
                <span className="font-display text-sm font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-218" data-mp="2rm7jp4p41vh6">
                  {t.steps.stepLabel} {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="font-display text-xl font-semibold uppercase tracking-wide text-cream sm:text-2xl" data-id="element-219" data-mp="31cseeh1nyfut">
                  {step.title}
                </h3>
              </div>
              <p className="mt-3 max-w-2xl text-base leading-relaxed text-cream/70" data-id="element-220" data-mp="3aaks5grqlfg3">
                {step.description}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}